const videoClickComponent = {
  schema: {},
  init: function () {
    this.el.sceneEl.addEventListener('click', evt => {
      const intersectedEl = evt.detail.intersectedEl;
      if (!intersectedEl) return;
      const videoId = intersectedEl.getAttribute('video_id');
      const videoEntityId = intersectedEl.getAttribute('video_entity_id');
      if (videoId && videoEntityId) {
        const video = document.getElementById(videoId);
        if (!video) return;
        const videoEntity = document.getElementById(videoEntityId);
        const isPaused = video.paused;
        const playBtnPlane = videoEntity.querySelector('.play-btn');
        const thumbnailEntity = videoEntity.querySelector('.video-thumbnail');
        if (isPaused) {
          video.play();
          playBtnPlane.setAttribute('visible', 'false');
          thumbnailEntity.setAttribute('visible', 'false');
        } else {
          video.pause();
          playBtnPlane.setAttribute('visible', 'true');
          thumbnailEntity.setAttribute('visible', 'true');
        }
      }
    });
  },
};

export { videoClickComponent };
